var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-btns-table w-100 d-flex justify-content-initial"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }